import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGroup, faBed, faDoorOpen, faBath } from "@fortawesome/free-solid-svg-icons";

const HouseFeatures = ({ house }) => {
  if (!house) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap gap-4 text-muted small mb-3">
      {house.guestsCount != null && (
        <div className="d-flex align-items-center gap-1">
          <FontAwesomeIcon icon={faUserGroup} />
          {house.guestsCount} gości
        </div>
      )}
      {house.bedsCount != null && (
        <div className="d-flex align-items-center gap-1">
          <FontAwesomeIcon icon={faBed} />
          {house.bedsCount} łóżka
        </div>
      )}
      {house.bedroomsCount != null && (
        <div className="d-flex align-items-center gap-1">
          <FontAwesomeIcon icon={faDoorOpen} />
          {house.bedroomsCount} sypialnie
        </div>
      )}
      {house.bathroomCount != null && (
        <div className="d-flex align-items-center gap-1">
          <FontAwesomeIcon icon={faBath} />
          {house.bathroomCount} łazienki
        </div>
      )}
    </div>
  );
};

export default HouseFeatures;
